import React from 'react';
import { useNavigate } from 'react-router-dom';

interface GenerateButtonProps {
  isGenerating: boolean;
  onGenerate: () => void;
  quotaExceeded?: boolean;
  label?: string;
}

const GenerateButton: React.FC<GenerateButtonProps> = ({
  isGenerating,
  onGenerate,
  quotaExceeded = false,
  label = 'Generate Custom Quiz'
}) => {
  const navigate = useNavigate();
  const isDisabled = isGenerating;
  
  const handleClick = () => {
    if (quotaExceeded) {
      navigate('/pricing');
    } else {
      onGenerate();
    }
  };
  
  return (
    <div className="d-grid gap-2">
      <button
        type="button"
        className="btn btn-lg py-3"
        style={{ 
          background: quotaExceeded 
            ? 'linear-gradient(135deg, #dc3545, #c82333)' 
            : 'linear-gradient(135deg, #667eea, #764ba2)',
          border: 'none',
          borderRadius: '15px',
          color: 'white',
          cursor: quotaExceeded ? 'pointer' : (isDisabled ? 'not-allowed' : 'pointer')
        }}
        onClick={handleClick}
        disabled={isDisabled}
      >
        {isGenerating ? (
          <>
            <span className="spinner-border spinner-border-sm me-2"></span>
            Generating Quiz...
          </>
        ) : quotaExceeded ? (
          <>
            <i className="fas fa-crown me-2"></i>
            Upgrade to Create More Quizzes
          </>
        ) : (
          <>
            <i className="fas fa-magic me-2"></i>
            {label}
          </>
        )}
      </button>
    </div>
  );
};

export default GenerateButton;